module.exports = __webpack_public_path__ + "img/chuantong.04fedc6e.png";